import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import AddCircleIcon from '@material-ui/icons/AddCircle';

import appStyles from '../../../../../App/app.module.css';
import style from '../manualEntryStyle.module.css';
import commonStyles from '../../../../common/common.module.css';

const iconFontSize = 30;
const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)'
    },
    awbIp:{
      padding: '6px 12px'
    }
  });

interface HeaderProps {
  classes: any;
  awbValue: string;
  handleChange: Function;
  addClicked: any;
  isDisabled: Function;
  handleKeyDown: any;
};

const GhaManualEntryHeader = (props: HeaderProps) => {

  const { classes } = props;

  return (
    <div className={ `${style.airwayField} ${ style.headerSearch }` }>

      <div className={ `${style.formControlWrapper} ${style.textFieldWrapper}` }>
        <TextField
          id="awb"
          autoFocus 
          onChange={ props.handleChange('awb') }
          value={ props.awbValue }
          onKeyDown={ props.handleKeyDown }
          variant= "outlined"
          placeholder="Enter Airwaybill"
          InputProps={{
            className: [commonStyles.searchIpField].join(' '),
            classes:{input: classes.awbIp}
          }}
          className={ commonStyles.searchWrapper }

        />
        <div className={ `${style.formControlWrapper} ${style.addButtonWrapper}` }>
          { !props.isDisabled()
            ? <AddCircleIcon color="primary" className={ [ classes.materialIcon ].join(' ') } onClick={ props.addClicked } />
            : <AddCircleIcon className={ [ classes.disabledIcon ].join(' ') } />
          }
        </div>
      </div>
      
    </div>
  );
}

export default withStyles(styles)(GhaManualEntryHeader);
